var React = require('react');

function IcFacebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"cx":"256","cy":"256","fill":"#3B5998","r":"256","key":0}),React.createElement("path",{"d":"M301.6,151.2c15.6,0,36.3,0,36.3,0V97c0,0-21.8,0-51.4,0c-29.6,0-68.1,19-68.1,74.2c0,10.3,0,25.4,0,43   h-49.1v56.1h49.1c0,69.9,0,146,0,146h21.8h17.3H277c0,0,0-78.8,0-146h48.8l8.1-56.1H277c0-18.4,0-31.8,0-35.7   C277,160.1,286,151.2,301.6,151.2z","fill":"#FFFFFF","key":1})]));
}

IcFacebook.defaultProps = {"enableBackground":"new 0 0 512 512","id":"Layer_1","version":"1.1","viewBox":"0 0 512 512","xmlSpace":"preserve"};

module.exports = IcFacebook;

IcFacebook.default = IcFacebook;
